import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { forgottenPassword } from '../../common/auth/actions'
import { fields } from '../../common/lib/redux-fields'
import { validateForgotPassword } from '../../common/auth/validations'
import formValidation from '../../common/lib/formValidation'
import { Button, TextInput } from '../components'

class ForgottenPasswordForm extends React.Component {
  async submitForm(e, fields) {
    e.preventDefault()
    const values = fields.$values()
    if (await this.props.submit(values) !== false) {
      fields.$reset()
    }
  }
  render() {
    const { fields, errorMessage, foundUser } = this.props
    return (
      <div>
        {
          foundUser ?
            <p>New password was sent on your email...</p>
          :
            <form onSubmit={e => this.submitForm(e, fields)}>
              <TextInput
                {...fields.email}
                placeholder="Email"
              />
              {errorMessage}
              <Button type="submit">Send new password</Button>
            </form>
        }
      </div>
    )
  }
}

ForgottenPasswordForm.defaultProps = {
  errorMessage: '',
  foundUser: false,
}

ForgottenPasswordForm.propTypes = {
  fields: PropTypes.object.isRequired,
  errorMessage: PropTypes.any,
  submit: PropTypes.func.isRequired,
  foundUser: PropTypes.bool,
}

const enhance = compose(
  connect((state) => ({
    foundUser: state.users.current,
  }),
  { forgottenPassword }),
  formValidation(props => ({
    validationFunc: validateForgotPassword,
    submitFunc: props.forgottenPassword,
  })),
  fields({
    path: 'ForgottenPasswordForm',
    fields: [
      'email',
    ],
  }),
)

export default enhance(ForgottenPasswordForm)



// WEBPACK FOOTER //
// ./src/browser/forms/ForgottenPasswordForm.js